<template>
  <fieldset>
    <div
      v-for="option in options"
      :key="option.label"
      class="radio-button-container"
    >
      <span class="radio-button">
        <input
          :id="`${option.label}-${option.value}`"
          :checked="option.checked"
          :value="option.value"
          type="radio"
          @input="$emit('selected-option', option.value || option.label)"
        >
      </span>
      <label
        :for="`${option.label}-${option.value}`"
        class="radio-button-label"
      >
        {{ option.label }}
      </label>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'LegendRadioButtons',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['selected-option'],
};
</script>

<style lang="scss" scoped>
.radio-button-label {
  font-family: main.$fontPrimary;
  color: #666;
  font-weight: 500;
  cursor: pointer;
}
.radio-button-container {
  cursor: pointer;
}
.radio-button {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  background: main.$npGray;

  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 2px;
  cursor: pointer;

  input[type="radio"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    border: 2px solid #fff;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    background: #fff;

    transition: 0.2s ease-in-out all;
    cursor: pointer;

    &:checked {
      background: main.$npGray;
    }
  }
}
</style>
